import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Job } from '../../model/tops.models';
import { formatDisplayDate } from '../../mixins/date-utils';

@Component({
  selector: 'app-job-card',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './job-card.component.html',
  styleUrl: './job-card.component.css',
})
export class JobCardComponent {
  @Input({ required: true }) job!: Job;
  @Output() edit = new EventEmitter<Job>();
  @Output() markCompleted = new EventEmitter<Job>();
  @Output() archive = new EventEmitter<Job>();
  @Output() delete = new EventEmitter<Job>();

  formatDate(value: Job['appointmentDate']): string {
    return formatDisplayDate(value);
  }

  statusClass(status: string | null): string {
    switch (status) {
      case 'Completed': return 'status-completed';
      case 'Archived': return 'status-archived';
      default: return 'status-progress';
    }
  }

  photoUrl(url: string | null): string | null {
    if (!url) return null;
    return url.startsWith('http') ? url : url;
  }

  runAction(event: MouseEvent, action: 'edit' | 'markCompleted' | 'archive' | 'delete'): void {
    event.preventDefault();
    event.stopPropagation();
    if (action === 'edit') this.edit.emit(this.job);
    if (action === 'markCompleted') this.markCompleted.emit(this.job);
    if (action === 'archive') this.archive.emit(this.job);
    if (action === 'delete') this.delete.emit(this.job);
  }
}
